import { getAuthHeadersFromCookie } from 'lib/AuthClient/cookie';

const fetchHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const _fetch =
  method =>
  async ({ url, headers = undefined, body = undefined }) => {
    const authHeaders = getAuthHeadersFromCookie();
    const response = await fetch(url, {
      method,
      headers: {
        ...authHeaders,
        ...fetchHeaders,
        ...headers,
      },
      body: JSON.stringify(body),
    });

    return response;
  };

const _postImage =
  () =>
  async ({ url, file }) => {
    const authHeaders = getAuthHeadersFromCookie();
    const formData = new FormData();
    formData.append('file', file, file.name);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...authHeaders,
      },
      body: formData,
    });

    return response;
  };

const _simpleFetch =
  method =>
  async ({ url, body = undefined }) => {
    const response = await fetch(url, {
      method,
      headers: {
        Accept: '*/*',
      },
      body: JSON.stringify(body),
    });

    return response;
  };

// TODO This needs a cleanup. I'm not sure we need this method any more. But maybe we should do something like repos for accessing data types?
const _fetch2 =
  method =>
  async ({ url, body = undefined }) => {
    const authHeaders = getAuthHeadersFromCookie();
    const response = await fetch(url, {
      method,
      headers: {
        ...authHeaders,
        ...fetchHeaders,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    return response.json();
  };

const exportedObject = {
  get2: _fetch2('GET'),
  get: _fetch('GET'),
  simpleGet: _simpleFetch('GET'),
  post: _fetch('POST'),
  postImage: _postImage(),
  put: _fetch('PUT'),
  delete: _fetch('DELETE'),
};

export default exportedObject;
